<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>晶片管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input
            placeholder="搜索：请输入晶片类型名称"
            class="input-with-select"
            v-model="queryInfo.wafer_type"
            clearable
            @change="getWafers()"
          >
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" icon="el-icon-search" @click="search()"
            >查询</el-button
          >
        </el-col>
        <el-col :span="15"> &nbsp; </el-col>
        <el-col :span="2">
          <el-button type="success" @click="addDialogVisible=true"
            >添加晶片</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="tableData"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        element-loading-text="数据加载中"
        highlight-current-row
      >
        <el-table-column type="index" fixed></el-table-column>
        <el-table-column
          prop="wafer_type"
          label="晶片类型"
          fixed
        >
        </el-table-column>
        <el-table-column prop="" label="第14孔位状态" width="180">
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              v-model="scope.row.is14th_open"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              @change="openChanged(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="edit(scope.row.id)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="_delete(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.currentPage"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog
      :visible.sync="addDialogVisible"
      width="50%"
      @close="addDialogClosed"
    >
      <div class="block" style="text-align:center; margin-bottom:55px;">
        <el-image
            style="height: 300px"
            src="https://program.yg-med.com/imgs/wafer.jpg"
            fit="fill"></el-image>
     </div>

      <!-- 内容主体区域 -->
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="80px"
        style="max-height: 500px; overflow-y: scroll;"
      >
        <el-form-item label="晶片类型">
          <el-input v-model="addForm.wafer_type"></el-input>
        </el-form-item>

        <el-form-item v-for="count in 15"
        :key="count" :label="`孔位${count}`">
          <el-col :span="11">
            <el-input v-model="addForm.holes_info[count-1].drug_chn_name" placeholder="药物中文名称"></el-input>
          </el-col>
          <el-col :span="11">
            <el-input v-model="addForm.holes_info[count-1].drug_eng_name" placeholder="药物英文名称"></el-input>
          </el-col>
          <el-col :span="2">
            <el-color-picker v-model="addForm.holes_info[count-1].hole_color"></el-color-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="add()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户的对话框 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      width="50%"
      @close="editDialogClosed"
    >
      <div class="block" style="text-align:center; margin-bottom:55px;">
          <el-image
              style="height: 300px"
              src="https://program.yg-med.com/imgs/wafer.jpg"
              fit="fill"></el-image>
      </div>
      <!-- 内容主体区域 -->
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editFormRef"
        label-width="80px"
        style="max-height: 500px; overflow-y: scroll;"
      >
        <el-form-item label="晶片类型id" prop="id" style="display: none">
          <el-input v-model="editForm.wafer_id"></el-input>
        </el-form-item>
        <el-form-item label="晶片类型" prop="wafer_type">
          <el-input v-model="editForm.wafer_type"></el-input>
        </el-form-item>
        <el-form-item v-for="count in 15"
        :key="count" :label="`孔位${count}`">
          <el-col :span="11">
            <el-input v-model="editForm.holes_info[count-1].drug_chn_name" placeholder="药物中文名称"></el-input>
          </el-col>
          <el-col :span="11">
            <el-input v-model="editForm.holes_info[count-1].drug_eng_name" placeholder="药物英文名称"></el-input>
          </el-col>
          <el-col :span="2">
            <el-color-picker v-model="editForm.holes_info[count-1].hole_color"></el-color-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      managerOptions: [],
      select: '2',
      // 查询参数
      queryInfo: {
        wafer_type: '',
        pageSize: 5,
        currentPage: 1
      },
      loading: true,
      tableData: [],
      addDialogVisible: false,
      total: 0,
      // 添加的表单数据
      addForm: {
        wafer_type: '',
        holes_info: []
      },
      // 添加表单的验证规则对象
      addFormRules: {
        wafer_type: [
          { required: true, message: '请输入晶片类型', trigger: 'blur' }
        ]
      },
      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,
      // 查询到的用户信息对象
      editForm: {
        wafer_id: '',
        wafer_type: '',
        holes_info: []
      },
      // 修改表单的验证规则对象
      editFormRules: {
        wafer_type: [
          { required: true, message: '请输入晶片类型', trigger: 'blur' }
        ]
      },
      role: ''
    }
  },
  created() {
    this.getWafers()
    for (let index = 0; index < 15; index++) {
      const element =
          {
            drug_chn_name: '',
            drug_eng_name: '',
            hole_color: ''
          }
      this.addForm.holes_info.push(element)
      this.editForm.holes_info.push(element)
    }
  },
  methods: {
    // 监听 switch 开关状态的改变
    async openChanged(row) {
      // console.log(row.status)
      await this.$http
        .post(
          'wafer/v1/change14th_hole/',
          this.qs.stringify({
            wafer_id: row.id,
            is14th_open: row.is14th_open === true ? '1' : '0'
          })
        )
        .then((res) => {
          if (res.data.status === 0) {
            this.$message.success(res.data.msg)
            // 重新获取列表数据
            this.getWafers()
          } else {
            row.status = !row.status
            this.$message.error(res.data.msg)
          }
        })
        .catch((error) => {
          row.status = !row.status
          console.log(error)
          this.$message.error('操作失败!')
        })
    },
    // 搜索
    async getWafers() {
      await this.$http
        .post('wafer/v1/list_wafer/', this.qs.stringify(this.queryInfo))
        .then((res) => {
          // console.log(res)
          if (res.data.status === 0) {
            this.$message.success(res.data.msg)
            this.tableData = res.data.data
            this.total = res.data.total
          } else {
            this.$message.error(res.data.msg)
          }
          //
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async add() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        // 可以发起添加用户的网络请求
        await this.$http
          .post('wafer/v1/add_wafer/', { data: JSON.stringify(this.addForm) })
          .then((res) => {
            const msg = res.data.msg
            if (res.data.status === 0) {
              this.$message.success(msg)
              // 隐藏添加用户的对话框
              this.addDialogVisible = false
              // 重新获取用户列表数据
              this.getWafers()
            } else {
              this.$message.error(msg)
            }
          })
          .catch((error) => {
            console.log(error)
            this.$message.error('操作失败！')
          })
      })
    },
    // 展示编辑对话框
    async edit(id) {
      // console.log(id)
      await this.$http
        .get('wafer/v1/get_wafer/', {
          params: {
            wafer_id: id
          }
        })
        .then((res) => {
          // console.log(res)
          this.editForm.wafer_id = res.data.data.id
          this.editForm.wafer_type = res.data.data.wafer_type
          this.editForm.holes_info = res.data.data.holes_info_vue
          this.editDialogVisible = true
        })
        .catch((error) => {
          console.log(error)
          this.$message.error('操作失败！')
        })
    },
    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.$refs.editFormRef.resetFields()
    },
    // 修改用户信息并提交
    save() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        // console.log(this.editForm)
        await this.$http
          .post('wafer/v1/update_wafer/', { data: JSON.stringify(this.editForm) })
          .then((res) => {
            const msg = res.data.msg
            if (res.data.status === 0) {
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getWafers()
              // 提示修改成功
              this.$message.success(msg)
            } else {
              this.$message.error(msg)
            }
          })
          .catch((error) => {
            console.log(error)
            this.$message.error('操作失败！')
          })
      })
    },
    async _delete(id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      // 如果用户确认删除，则返回值为字符串 confirm
      // 如果用户取消了删除，则返回值为字符串 cancel
      // console.log(confirmResult)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }

      await this.$http
        .delete('/delete_wafer/', {
          params: {
            wafer_id: id
          }
        })
        .then((res) => {
          if (res.data.status === 0) {
            this.$message.success(res.data.msg)
          } else {
            this.$message.error(res.data.msg)
          }
          this.getWafers()
        })
        .catch((error) => {
          console.log(error)
          this.$message.error('操作失败！')
        })
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.queryInfo.pageSize = val
      this.getWafers()
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.queryInfo.currentPage = val
      this.getWafers()
    },
    search() {
      // 当前页数重置为1
      this.queryInfo.currentPage = 1
      this.getWafers()
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
</style>
